import PropTypes from 'prop-types';
export const tilePropTypes = {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Description
   */
  description: PropTypes.string,
  /**
   * External products
   */
  eternal: PropTypes.bool,
  /**
   * Button as an object of label and href
   */
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  })
};